const s = {
  name: "AdyenForPlatformsManage",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21.3,20c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S21.3,19.3,21.3,20z"/>
		<path class="st0" d="M16,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2s-1.2,0.6-1.2,1.2C14.8,20.7,15.4,21.2,16,21.2z"/>
		<path class="st0" d="M25.3,20c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2S25.3,19.3,25.3,20z"/>
		<path class="st0" d="M9,20c0-6.1,4.9-11,11-11s11,4.9,11,11s-4.9,11-11,11S9,26.1,9,20z M20,11c-5,0-9,4-9,9s4,9,9,9s9-4,9-9
			S25,11,20,11z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20c0,11-9,20-20,20S0,31,0,20z M20,2C10.1,2,2,10.1,2,20s8.1,18,18,18
			s18-8.1,18-18S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as AdyenForPlatformsManage
};
